import {observable} from 'mobx';
import {construct, ModelProperties} from 'utils';

export class AccessGroup {
    @observable id!: number;

    @observable tag!: string;

    @observable description!: string;

    constructor(group?: ModelProperties<AccessGroup>) {
        if (group) {
            construct(this, group);
        }
    }
}